import { ReactElement } from 'react';

export const QuoteCardPill = (props: {
  icon: ReactElement;
  text: string;
  isDifferent?: boolean;
}): ReactElement => {
  const { icon, text, isDifferent } = { ...props };
  return (
    <div
      className={`h-5 mt-1 ml-1 rounded-lg flex border-[0.5px] w-fit ${
        isDifferent ? 'border-primaryYellow1' : 'border-profilePage'
      }`}>
      <div
        className={`bg-specialValue flex justify-center items-center rounded-l-lg w-6 py-1 pl-0.5 ${
          isDifferent ? 'bg-statusBg' : 'bg-specialValue'
        }`}>
        {icon}
      </div>
      <div className="px-2 text-darkPurple font-semibold text-xs py-0.5">{text}</div>
    </div>
  );
};

export const OrderQuoteCardPill = (props: { icon: ReactElement; text: string}): ReactElement => {
  const { icon, text} = { ...props };
  return (
    <div className={`h-7 mt-1 ml-1 rounded-lg flex border-[0.5px] border-profilePage w-fit`}>
      <div className="bg-specialValue flex justify-center items-center rounded-l-lg w-6 py-2 pl-0.5">{icon}</div>
      <div className="px-2 text-gray1 font-semibold text-sm pt-[5px]">{text}</div>
    </div>
  );
};
